import { createReducer } from '@reduxjs/toolkit';
import { requestActions, addComparisonProduct, removeComparisonProduct, removeAllComparisonProducts, setInitialComparisonState, setComparisonOrderProducts, } from './actions';
export const initialState = {
    isLoading: false,
    isLoaded: false,
    products: [],
    orderProducts: [],
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(requestActions.request, (state) => ({
        ...state,
        isLoading: true,
    }))
        .addCase(requestActions.success, (state, action) => ({
        ...state,
        products: action.payload.data.sort((productA, productB) => state.orderProducts.indexOf(productA.key) - state.orderProducts.indexOf(productB.key)),
        isLoaded: true,
        isLoading: false,
    }))
        .addCase(requestActions.failure, (state) => ({
        ...state,
        isLoading: false,
        isLoaded: true,
    }))
        .addCase(addComparisonProduct, (state, action) => ({
        ...state,
        products: [...state.products, action.payload],
    }))
        .addCase(removeComparisonProduct, (state, action) => ({
        ...state,
        products: state.products.filter((product) => product.key !== action.payload),
    }))
        .addCase(removeAllComparisonProducts, (state) => ({
        ...state,
        products: [],
    }))
        .addCase(setInitialComparisonState, () => initialState)
        .addCase(setComparisonOrderProducts, (state, action) => ({
        ...state,
        orderProducts: action.payload,
    }));
});
